import { type User } from "@prisma/client";

export default function ButtonBlock({
  user,
  onBlocked,
  className,
}: {
  user: Pick<User, "id" | "firstName" | "lastName">;
  onBlocked: () => void;
  className?: string;
}) {
  const handleBlock = async () => {
    try {
      await fetch(`${import.meta.env.VITE_API_URL}/users/block/${user.id}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Vous avez bloqué " + user.firstName + " " + user.lastName);
      onBlocked();
    } catch (error) {
      console.error("Error blocking user:", error);
    }
  };

  return (
    <button type="button" className={`block text-gray-700 hover:bg-gray-100 ${className}`} onClick={handleBlock}>
      Bloquer
    </button>
  );
}
